import { render, staticRenderFns } from "./MyKifus.vue?vue&type=template&id=bc7f4f10&scoped=true&"
import script from "./MyKifus.vue?vue&type=script&lang=js&"
export * from "./MyKifus.vue?vue&type=script&lang=js&"
import style0 from "./MyKifus.vue?vue&type=style&index=0&id=bc7f4f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7f4f10",
  null
  
)

export default component.exports